import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './service-worker';
import './index.css';

// Suppress harmless ResizeObserver errors from react-grid-layout
const resizeObserverErrorHandler = (event: ErrorEvent) => {
  if (
    event.message === 'ResizeObserver loop completed with undelivered notifications.' ||
    event.message === 'ResizeObserver loop limit exceeded'
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();
